import { render, staticRenderFns } from "./VerMaisTooltip.vue?vue&type=template&id=a98cd05a&scoped=true"
import script from "./VerMaisTooltip.vue?vue&type=script&lang=js"
export * from "./VerMaisTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98cd05a",
  null
  
)

export default component.exports